import { formatMoney } from '../../../game/demo/inventory/money';
import eventBus from '../../utils/emitter-event-bus';
import { InventoryEventBus, InventoryReader } from '../inventory/inventory.model';

// Always-visible coin counter. Coins are a regular inventory item ('coins'),
// so the HUD just reflects the inventory state and refreshes on every change.
export class CoinsHud {
  private readonly element = document.querySelector<HTMLElement>('.js-coin-hud');
  // Last coin amount, used to pulse the HUD on any coin movement (gained or
  // spent).
  private coins = 0;

  constructor(private readonly reader: InventoryReader) {
    this.coins = this.amount();
    eventBus.on(InventoryEventBus.changed, () => this.onChange());
    this.render();
  }

  private amount(): number {
    return this.reader.getState().items.coins ?? 0;
  }

  private onChange(): void {
    const amount = this.amount();
    if (amount !== this.coins) this.bump();
    this.coins = amount;
    this.render();
  }

  // Restart the pulse (remove + reflow + re-add) so successive changes each bump.
  private bump(): void {
    if (!this.element) return;
    this.element.classList.remove('is-bump');
    void this.element.offsetWidth;
    this.element.classList.add('is-bump');
  }

  private render(): void {
    if (!this.element) return;
    this.element.textContent = `🪙 ${formatMoney(this.amount())}`;
  }
}
